import React, { useState, useEffect } from 'react';
import CarouselItem from './CarouselItem';

const Carousel = ({ children, autoPlay = true, interval = 5000 }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  
  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = React.Children.count(children) - 1;
    } else if (newIndex >= React.Children.count(children)) {
      newIndex = 0;
    }
    
    setActiveIndex(newIndex);
  };
  
  useEffect(() => {
    if (!autoPlay) return;
    
    const intervalId = setInterval(() => {
      if (!paused) {
        updateIndex(activeIndex + 1);
      }
    }, interval);
    
    return () => {
      clearInterval(intervalId);
    };
  }, [activeIndex, paused, autoPlay, interval]);
  
  return (
    <div 
      className="carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div 
        className="carousel-inner" 
        style={{ transform: `translateX(-${activeIndex * 100}%)` }}
      >
        {React.Children.map(children, (child) => {
          return (
            <CarouselItem width="100%">
              {child}
            </CarouselItem>
          );
        })}
      </div>
      
      <div className="carousel-indicators">
        {React.Children.map(children, (child, index) => {
          return (
            <button 
              className={`carousel-indicator-item ${index === activeIndex ? "active" : ""}`}
              onClick={() => updateIndex(index)}
            />
          );
        })}
      </div>
      
      <button 
        className="carousel-control carousel-control-prev" 
        onClick={() => updateIndex(activeIndex - 1)}
      >
        &#10094;
      </button>
      <button 
        className="carousel-control carousel-control-next" 
        onClick={() => updateIndex(activeIndex + 1)}
      >
        &#10095;
      </button>
    </div>
  );
};

export default Carousel;